import { __assign } from "tslib";
import React, { useState, useMemo, useContext } from 'react';
// tslint:disable-next-line: no-empty
var noop = function () { };
export var CommentContext = React.createContext({
    comment: {},
    isEditing: false,
    isReplying: false,
    isPeeking: false,
    isActionMenuOpen: false,
    isCommentVisible: true,
    setEditingState: noop,
    setActionMenuOpen: noop,
    setPeeking: noop,
});
CommentContext.displayName = 'CommentContext';
function isCommentHidden(_a, isPeeking) {
    var isDeleted = _a.isDeleted, isHidden = _a.isHidden, isAdminHidden = _a.isAdminHidden, isSpam = _a.isSpam, replies = _a.replies;
    // these rules match those in CommentBody
    var isVisible = !isAdminHidden && !isDeleted;
    if (!isPeeking && isSpam && replies !== 0) {
        return true;
    }
    if (!isPeeking && (isHidden || !isVisible) && replies !== 0) {
        return true;
    }
    if ((isHidden || !isVisible || isSpam) && !isPeeking) {
        return true;
    }
    return false;
}
export var CommentContextProvider = function (_a) {
    var children = _a.children, comment = _a.comment, onEditingStateChange = _a.onEditingStateChange;
    var _b = useState('none'), editingState = _b[0], setEditingState = _b[1];
    var _c = useState(false), isPeeking = _c[0], setPeeking = _c[1];
    var _d = useState(false), isActionMenuOpen = _d[0], setActionMenuOpen = _d[1];
    var isCommentVisible = !isCommentHidden(comment, isPeeking);
    var contextState = useMemo(function () { return ({
        comment: comment,
        isEditing: editingState === 'editing',
        isReplying: editingState === 'replying',
        isPeeking: isPeeking,
        isActionMenuOpen: isActionMenuOpen,
        isCommentVisible: isCommentVisible,
        setEditingState: function (state) {
            setEditingState(state);
            if (onEditingStateChange) {
                onEditingStateChange(state);
            }
        },
        setPeeking: setPeeking,
        setActionMenuOpen: setActionMenuOpen,
    }); }, [
        comment,
        editingState,
        onEditingStateChange,
        isActionMenuOpen,
        isCommentVisible,
        isPeeking,
    ]);
    return (React.createElement(CommentContext.Provider, { value: contextState }, children));
};
CommentContextProvider.displayName = 'CommentContextProvider';
export var withCommentContext = function (Component) {
    var Decorated = function (props) {
        var context = useContext(CommentContext);
        // prettier-ignore
        return React.createElement(Component, __assign({}, props, context));
    };
    Decorated.displayName = "withCommentContext(" + (Component.displayName ||
        'Component') + ")";
    return Decorated;
};
//# sourceMappingURL=CommentContext.js.map